import { ART_API } from "../config";
import { DesignDoc } from "../types/emblemData";

export const createDesign = async (wizardData: DesignDoc): Promise<{ success: boolean; designId?: string }> => {
    try {
      const token = localStorage.getItem("customerToken") || "";
      const response = await fetch(`${ART_API}/api/v1/Designs`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(wizardData),
      });
      const json = await response.json();
      return json ? { success: true, designId: json.id } : { success: false };
    } catch {
      return { success: false };
    }
  };

  export const designPrice = async (designId: string): Promise<{ success: boolean; pricing?: any }> => {
    try {
      const token = localStorage.getItem("customerToken") || "";
      const response = await fetch(`${ART_API}/api/v1/DesignPrices`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({id: designId }),
      });
      const json = await response.json();
      return json.success ? { success: true, pricing: json } : { success: false };
    } catch {
      return { success: false };
    }
  };

  export const getVolumePrices = async (productId: string) => {
    try {
      const token = localStorage.getItem("customerToken") || "";
      const response = await fetch(`${ART_API}/sana/graph`, {
          method: 'POST',
          headers: {
              'Accept': '*/*',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
              query: `query GetVolumePrices($productId: String!) {
                          catalog {
                              volumePrices(productId: $productId) {
                                  discountPercent
                                  price
                                  variant { id }
                                  quantity
                                  uomId
                              }
                          }
                      }`,
              variables: { productId }
          }),
      });
      
      const json = await response.json();
      return json.data ? { success: true, response: json.data } : { success: false };
    } catch {
      return { success: false };
    }
  };


  export const addProductToBasket = async (configDataEntity: any) => {
    try {
      const token = localStorage.getItem("customerToken") || "";
      const response = await fetch(ART_API, {
          method: 'POST',
          headers: {
              'Accept': '*/*',
              'Content-Type': 'application/json; charset=UTF-8',
              'x-languageid': '1033',
              'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
              query: `mutation AddProductConfigurationToBasket($configDataEntity: [WizardConfiguredProduct]){
                          basket {
                              addConfigurableProduct(configDataEntity: $configDataEntity) {
                                  basket(calculated: false) {
                                      totalCount
                                  }
                              }
                          }
                      }`,
              variables: { configDataEntity }
          }),
      });
      const json = await response.json();
      return json.data ? { success: true, response: json.data } : { success: false };
    } catch {
      return { success: false };
    }
  };